// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete listener for a parse tree produced by sequenceParser.
export default class sequenceParserListener extends antlr4.tree.ParseTreeListener {

	// Enter a parse tree produced by sequenceParser#prog.
	enterProg(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#prog.
	exitProg(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#title.
	enterTitle(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#title.
	exitTitle(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#head.
	enterHead(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#head.
	exitHead(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#group.
	enterGroup(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#group.
	exitGroup(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#starterExp.
	enterStarterExp(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#starterExp.
	exitStarterExp(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#starter.
	enterStarter(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#starter.
	exitStarter(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#participant.
	enterParticipant(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#participant.
	exitParticipant(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#stereotype.
	enterStereotype(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#stereotype.
	exitStereotype(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#label.
	enterLabel(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#label.
	exitLabel(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#participantType.
	enterParticipantType(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#participantType.
	exitParticipantType(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#name.
	enterName(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#name.
	exitName(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#width.
	enterWidth(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#width.
	exitWidth(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#emoji.
	enterEmoji(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#emoji.
	exitEmoji(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#block.
	enterBlock(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#block.
	exitBlock(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#ret.
	enterRet(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#ret.
	exitRet(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#returnAsyncMessage.
	enterReturnAsyncMessage(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#returnAsyncMessage.
	exitReturnAsyncMessage(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#divider.
	enterDivider(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#divider.
	exitDivider(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#dividerNote.
	enterDividerNote(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#dividerNote.
	exitDividerNote(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#stat.
	enterStat(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#stat.
	exitStat(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#par.
	enterPar(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#par.
	exitPar(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#opt.
	enterOpt(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#opt.
	exitOpt(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#critical.
	enterCritical(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#critical.
	exitCritical(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#section.
	enterSection(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#section.
	exitSection(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#creation.
	enterCreation(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#creation.
	exitCreation(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#ref.
	enterRef(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#ref.
	exitRef(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#creationBody.
	enterCreationBody(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#creationBody.
	exitCreationBody(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#message.
	enterMessage(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#message.
	exitMessage(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#messageBody.
	enterMessageBody(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#messageBody.
	exitMessageBody(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#fromTo.
	enterFromTo(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#fromTo.
	exitFromTo(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#func.
	enterFunc(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#func.
	exitFunc(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#from.
	enterFrom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#from.
	exitFrom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#to.
	enterTo(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#to.
	exitTo(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#signature.
	enterSignature(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#signature.
	exitSignature(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#invocation.
	enterInvocation(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#invocation.
	exitInvocation(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#assignment.
	enterAssignment(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#assignment.
	exitAssignment(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#asyncMessage.
	enterAsyncMessage(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#asyncMessage.
	exitAsyncMessage(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#content.
	enterContent(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#content.
	exitContent(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#construct.
	enterConstruct(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#construct.
	exitConstruct(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#type.
	enterType(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#type.
	exitType(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#assignee.
	enterAssignee(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#assignee.
	exitAssignee(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#methodName.
	enterMethodName(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#methodName.
	exitMethodName(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#parameters.
	enterParameters(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#parameters.
	exitParameters(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#parameter.
	enterParameter(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#parameter.
	exitParameter(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#namedParameter.
	enterNamedParameter(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#namedParameter.
	exitNamedParameter(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#declaration.
	enterDeclaration(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#declaration.
	exitDeclaration(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#tcf.
	enterTcf(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#tcf.
	exitTcf(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#tryBlock.
	enterTryBlock(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#tryBlock.
	exitTryBlock(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#catchBlock.
	enterCatchBlock(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#catchBlock.
	exitCatchBlock(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#finallyBlock.
	enterFinallyBlock(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#finallyBlock.
	exitFinallyBlock(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#alt.
	enterAlt(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#alt.
	exitAlt(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#ifBlock.
	enterIfBlock(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#ifBlock.
	exitIfBlock(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#elseIfBlock.
	enterElseIfBlock(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#elseIfBlock.
	exitElseIfBlock(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#elseBlock.
	enterElseBlock(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#elseBlock.
	exitElseBlock(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#braceBlock.
	enterBraceBlock(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#braceBlock.
	exitBraceBlock(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#loop.
	enterLoop(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#loop.
	exitLoop(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#assignmentExpr.
	enterAssignmentExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#assignmentExpr.
	exitAssignmentExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#funcExpr.
	enterFuncExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#funcExpr.
	exitFuncExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#atomExpr.
	enterAtomExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#atomExpr.
	exitAtomExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#orExpr.
	enterOrExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#orExpr.
	exitOrExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#additiveExpr.
	enterAdditiveExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#additiveExpr.
	exitAdditiveExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#relationalExpr.
	enterRelationalExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#relationalExpr.
	exitRelationalExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#plusExpr.
	enterPlusExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#plusExpr.
	exitPlusExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#notExpr.
	enterNotExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#notExpr.
	exitNotExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#unaryMinusExpr.
	enterUnaryMinusExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#unaryMinusExpr.
	exitUnaryMinusExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#creationExpr.
	enterCreationExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#creationExpr.
	exitCreationExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#parenthesizedExpr.
	enterParenthesizedExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#parenthesizedExpr.
	exitParenthesizedExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#multiplicationExpr.
	enterMultiplicationExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#multiplicationExpr.
	exitMultiplicationExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#equalityExpr.
	enterEqualityExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#equalityExpr.
	exitEqualityExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#andExpr.
	enterAndExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#andExpr.
	exitAndExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#numberAtom.
	enterNumberAtom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#numberAtom.
	exitNumberAtom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#numberUnitAtom.
	enterNumberUnitAtom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#numberUnitAtom.
	exitNumberUnitAtom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#moneyAtom.
	enterMoneyAtom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#moneyAtom.
	exitMoneyAtom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#booleanAtom.
	enterBooleanAtom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#booleanAtom.
	exitBooleanAtom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#idAtom.
	enterIdAtom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#idAtom.
	exitIdAtom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#digitLeadingNameAtom.
	enterDigitLeadingNameAtom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#digitLeadingNameAtom.
	exitDigitLeadingNameAtom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#stringAtom.
	enterStringAtom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#stringAtom.
	exitStringAtom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#nilAtom.
	enterNilAtom(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#nilAtom.
	exitNilAtom(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#parExpr.
	enterParExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#parExpr.
	exitParExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#condition.
	enterCondition(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#condition.
	exitCondition(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#inExpr.
	enterInExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#inExpr.
	exitInExpr(ctx) {
	}


	// Enter a parse tree produced by sequenceParser#textExpr.
	enterTextExpr(ctx) {
	}

	// Exit a parse tree produced by sequenceParser#textExpr.
	exitTextExpr(ctx) {
	}



}